import { DateTime } from 'luxon';

export function hotelErrorOf(
  message: string | null | undefined,
): {
  code: string | null;
  detail: string;
} {
  const match = /ERROR_HOTEL_([A-Z_]+): ?([\s\S]*)/.exec(message ?? '');
  return match ? { code: match[1], detail: match[2] } : { code: null, detail: message ?? '' };
}

export interface ChequeLine {
  id: string;
  title: string;
  categoryId: string;
  vatRate: number;
  count: number;
  fraction: number;
  amount: number;
  discount: number;
  isMessage?: boolean;
}

function absorbRoundingIntoLastLine<T extends { amount: number }>(lines: T[], total: number): T[] {
  const rounding = total - lines.reduce((sum, line) => sum + line.amount, 0);
  if (rounding === 0 || lines.length === 0) {
    return lines;
  }
  const last = lines[lines.length - 1];
  return [...lines.slice(0, -1), { ...last, amount: last.amount + rounding }];
}

const TIME_ZONE = 'Europe/Stockholm';
const BUSINESS_DAY_END = { hour: 5, minute: 30 };

/** Baemingo's business day, which ends at 05:30 Swedish time, like the hotel service's */
export function businessDateOf(instant: DateTime): string {
  const local = instant.setZone(TIME_ZONE);
  const dayEnd = local.set({ ...BUSINESS_DAY_END, second: 0, millisecond: 0 });
  return (local < dayEnd ? local.minus({ days: 1 }) : local).toISODate() ?? '';
}

/** A room charge can only be reopened on the business day it was made */
export const isSameBusinessDay = (chargedAt: string, now: DateTime = DateTime.now()) =>
  businessDateOf(DateTime.fromISO(chargedAt)) === businessDateOf(now);

export function chequeItems(items: ChequeLine[], amount: number) {
  const lines = items
    .filter((item) => !item.isMessage && item.amount - item.discount !== 0)
    .map((item) => ({
      itemId: item.id,
      name: item.title,
      categoryId: item.categoryId || 'uncategorized',
      vatRate: item.vatRate,
      quantity: (item.count || 1) * (item.fraction || 1),
      amount: Math.round(item.amount - item.discount),
    }));
  return absorbRoundingIntoLastLine(lines, amount);
}
